// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import './assets/theme/index.css'
import './assets/element-reset.css'
import './assets/base.css'
import ElementUI from 'element-ui'
import router from './router'
import axios from 'axios'//网络组件
import VueAxios from 'vue-axios'//网络组件
import md5 from 'js-md5'
import Cookies from 'js-cookie'
import utils from './js/utils'
import store from './store/index'//数据持久化组件库
import JDatePicker from 'vue-jlunar-datepicker';
Vue.component("j-date-picker",JDatePicker);
Vue.prototype.$cookies = Cookies
Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.use(VueAxios,axios)
Vue.prototype.$md5 = md5
Vue.prototype.$store = store//在文件中可使用 this.$store
Vue.prototype.utils = utils
/* eslint-disable no-new */
var vue = new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})
router.beforeEach((to, from, next) => {
  if(to.meta.title){
    document.title = to.meta.title
  }
  console.log("to:")
  console.log(to)
  if(to.meta.requireAuth){
    var token = vue.$cookies.get('token')
    if(!token || token.length == 0){
      next({path:'/Login'})
      return
    }
    if(to.path == '/addPrescriptionContact'){
      var userInfo = vue.$store.getters.getUserInfo
      //可以开药方或者是自拟组方时
      if((!vue.utils.isEmptyObject(userInfo) && userInfo.prescription == 'Y') || to.query.mode == 2){
        next()
        return
      }else{
        if(!userInfo.doctor || parseInt(userInfo.doctor.status) < 4){
          next({path:'/apply'})
        }else{
          next({path:'/applying'})
        }
        return
      }
    }
   }
  if(to.path == '/'){
    sessionStorage.clear()
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js